import * as z from "zod";

const inboundConsolidationAddressSchema_ = z.object({
  name: z.string(),
  address1: z.string().nullable(),
  address2: z.string().nullable(),
  city: z.string().nullable(),
  province: z.string().nullable(),
  zip: z.string().nullable(),
  countryCode: z.string().nullable(),
});
export const inboundConsolidationAddressSchema: z.ZodType<InboundConsolidationAddress> =
  inboundConsolidationAddressSchema_;
export interface InboundConsolidationAddress extends z.infer<
  typeof inboundConsolidationAddressSchema_
> {}

const inboundConsolidationRouteEndpointSchema_ = z.object({
  name: z.string(),
  city: z.string().nullable(),
  province: z.string().nullable(),
});
export const inboundConsolidationRouteEndpointSchema: z.ZodType<InboundConsolidationRouteEndpoint> =
  inboundConsolidationRouteEndpointSchema_;
export interface InboundConsolidationRouteEndpoint extends z.infer<
  typeof inboundConsolidationRouteEndpointSchema_
> {}
